import WebhookList from './WebhookList';
import WebhookCreate from './WebhookCreate';

export default {
  list: WebhookList,
  create: WebhookCreate,
  edit: WebhookCreate
}
